import React, { Component } from "react";
import compose from "recompose/compose";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";

const styles = {
  container: {
    height: "13px",
    width: "28px",
    backgroundColor: "red",
  },
};

const palette = {
  success: "#20a11b",
  error: "#ba2800",
  warning: "#dbca00",
  none: "#d4d4d4",
};

class LightStatus extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, status } = this.props;
    return (
      <div
        className={classes.container}
        style={{ backgroundColor: palette[status] }}
      />
    );
  }
}

export default compose(withRouter, withStyles(styles))(LightStatus);
